module.exports = __webpack_public_path__ + "img/Kerry Underwood.db3dabf8.jpg";